import EventosCalendarioLetivoPage from "@/Pages/EventosCalendarioLetivo/index.vue";
import NewEditEventosCalendarioLetivoPage from "@/Pages/EventosCalendarioLetivo/NewEditEventosCalendarioLetivoPage.vue";
import store from "@/store";
import authService from "@/Services/AuthService";
import { can } from "@/plugins/can";
import { aplicarModulos } from "./modulos";

const checkPermission = (permissions) => {
  return async (to, from, next) => {
    const user = store.getters["Auth/user"];
    if (!user && authService.isLoggedIn()) {
      try {
        await authService.syncUserWithStore();
      } catch (e) {
        // ignore
      }
    }
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

const rotas = [
  {
    path: "/eventos-calendario-letivo/",
    name: "eventos-calendario-letivo",
    component: EventosCalendarioLetivoPage,
    beforeEnter: checkPermission(["calendarioLetivo.*", "eventosCalendarioLetivo.eventosCreate"]),
  },
  {
    path: "/eventos-calendario-letivo/create",
    name: "eventos-calendario-letivo.create",
    component: NewEditEventosCalendarioLetivoPage,
    props: { editing: false },
  },
  {
    path: "/eventos-calendario-letivo/edit/:evento_id",
    name: "eventos-calendario-letivo.edit",
    component: NewEditEventosCalendarioLetivoPage,
    props: { editing: true },
  },
];

// Rota => módulo (Administração > Configurações).
const MODULO_POR_ROTA = {
  "eventos-calendario-letivo": "calendario",
  "eventos-calendario-letivo.create": "calendario",
  "eventos-calendario-letivo.edit": "calendario",
};

export default aplicarModulos(rotas, MODULO_POR_ROTA);
